import { render, staticRenderFns } from "./TFFWelcome.vue?vue&type=template&id=1313bbf6&scoped=true"
import script from "./TFFWelcome.vue?vue&type=script&lang=js"
export * from "./TFFWelcome.vue?vue&type=script&lang=js"
import style0 from "./TFFWelcome.vue?vue&type=style&index=0&id=1313bbf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1313bbf6",
  null
  
)

export default component.exports